import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVideosAggregation } from '../../services/VideoService';
import { VideoAggregationResponse } from '../../types/Videos';
import { FeaturesManagement } from '../../../featuresControl';

function useGetVideosCount(fleetId: string, query: string, enabled = true): UseQueryResult<VideoAggregationResponse> {
  return useQuery(
    ['videos-aggregation', fleetId, query],
    async (): Promise<VideoAggregationResponse> => getVideosAggregation(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled,
    },
  );
}

export default useGetVideosCount;
